
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.999 3.75c3.62-.055 7.249 2.445 9.482 4.9l.002.003a2.01 2.01 0 010 2.691l-.002.002C17.3 13.748 13.68 16.306 10 16.25c-3.68.056-7.3-2.501-9.48-4.903l-.002-.002a2.01 2.01 0 010-2.691l.002-.002c2.23-2.456 5.86-4.956 9.48-4.9zM1.445 9.49a.76.76 0 000 1.017c2.09 2.302 5.394 4.545 8.543 4.492h.021c3.15.053 6.454-2.19 8.546-4.492a.76.76 0 000-1.017C16.417 7.14 13.103 4.95 10.01 5h-.02c-3.097-.05-6.41 2.14-8.546 4.49z"}}),_c('path',{attrs:{"d":"M10 5.701c-2.4 0-4.3 1.9-4.3 4.3s1.9 4.3 4.3 4.3 4.3-1.9 4.3-4.3-1.9-4.3-4.3-4.3zm0 7.5c-1.8 0-3.2-1.4-3.2-3.2 0-1.8 1.4-3.2 3.2-3.2 1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2z"}})])
          )
        }
      }
    